import React from 'react';

const LOGO_MARK_SRC = `${process.env.PUBLIC_URL || ''}/assets/brand/0e3_pos/logo-mark.svg`;
const APP_VERSION = process.env.REACT_APP_APP_VERSION || '0.1.0';

/**
 * Oculta el splash estático de index.html en cuanto React termina el bootstrap.
 */
export function dismissAppBootstrapSplash() {
  if (typeof document === 'undefined') return;
  const el = document.getElementById('app-bootstrap-splash');
  if (!el || el.dataset.dismissed === '1') return;
  el.dataset.dismissed = '1';
  el.classList.add('app-bootstrap-splash--hide');
  window.setTimeout(() => {
    el.remove();
  }, 220);
}

/**
 * Pantalla de carga inicial alineada a la identidad 0E3 (web, PWA, WebView Android).
 */
const AppBootstrapSplash = ({
  productName = '0E3 POS',
  message = 'Preparando tu espacio de trabajo...',
  showVersion = true,
  fullViewport = true,
  className = ''
}) => {
  const rootClass = [
    'app-bootstrap-splash',
    'app-bootstrap-splash--force-dark',
    fullViewport ? 'app-bootstrap-splash--viewport' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} role="status" aria-live="polite" aria-busy="true">
      <div className="app-bootstrap-splash__inner">
        <img
          src={LOGO_MARK_SRC}
          alt=""
          className="app-bootstrap-splash__logo app-bootstrap-splash__pulse"
          width={72}
          height={72}
          decoding="async"
          draggable={false}
        />
        <p className="app-bootstrap-splash__brand">{productName}</p>
        <p className="app-bootstrap-splash__message">{message}</p>
        <div className="app-bootstrap-splash__bar" aria-hidden="true">
          <span className="app-bootstrap-splash__bar-fill" />
        </div>
        {showVersion ? (
          <p className="app-bootstrap-splash__version">v{APP_VERSION}</p>
        ) : null}
      </div>
    </div>
  );
};

export default AppBootstrapSplash;
